var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"600px","src":_vm.mediaLocation}})])
}
var staticRenderFns = []

export { render, staticRenderFns }